import * as React from 'react'
import { Card } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { PositionNumber } from 'api/common/constants'
import { EarningResponse } from 'api/common/responses'
import earningsAPI from 'api/earnings'
import Footer from 'components/Footer'
import Header from 'components/Header'
import InputSelectField from 'components/InputSelectField'
import loginData from 'utilities/loginData'
import { positions, getTeamsOptions } from 'utilities/resources/options'
import { autoCast, dateFormatter, numberFormat } from 'utilities/typeUtility'

const SalesCard: React.FC<{
  title: string
  peoples?: number
  amount?: number
}> = ({ title, peoples, amount }) => (
  <Card body className="mt-3" bg="light">
    <div className="fw-bold">{title}</div>
    <div className="note">※ゲーム内課金です</div>
    <div className="note">※登録人数は累計の人数表示です</div>
    <hr className="my-3" />
    <div>
      {numberFormat(peoples)}人 / <span className="fw-bold">￥ {numberFormat(amount)}</span>
    </div>
  </Card>
)

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [positionNumber, setPositionNumber] = React.useState<string>(String(PositionNumber.MainPosition))
  const [monthAgo, setMonthAgo] = React.useState(0)
  const [earningsData, setEarningsData] = React.useState<EarningResponse>({ selectablePositions: [] })
  const { yesterday, periodRange, targetDate } = React.useMemo(() => {
    const now = new Date()
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)

    const targetMonth = new Date(now.getFullYear(), now.getMonth() - monthAgo, 1)

    return {
      yesterday,
      periodRange: {
        firstDay: targetMonth,
        lastDay: new Date(targetMonth.getFullYear(), targetMonth.getMonth() + 1, 0),
      },
      targetDate: targetMonth,
    }
  }, [monthAgo])
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    }
  }, [navigate])
  React.useEffect(() => {
    earningsAPI(autoCast(positionNumber), monthAgo, (response: EarningResponse) => {
      setEarningsData(response)
    })
  }, [positionNumber, monthAgo])

  const selectablePositions = positions.filter(({ key }) => earningsData.selectablePositions?.includes(autoCast(key)))
  return (
    <>
      <Header title="組織管理" />
      <main>
        <section className="mx-4 my-5">
          <Card className="mt-4 p-2" bg="light">
            <div className="note text-center">前日（{dateFormatter(yesterday, 'yyyy/MM/dd')}）までの集計データ</div>
          </Card>
          <Card body className="border-0 mt-4 p-2">
            <InputSelectField name="position" label="ポジション選択" items={selectablePositions} bold setValue={setPositionNumber} />
          </Card>
          <Card body className="border-0 mt-4 p-2">
            <InputSelectField name="team" label="集計期間選択" items={getTeamsOptions()} bold setValue={(value) => setMonthAgo(Number(value))} />
            <Card className="mt-3 p-2" bg="light">
              <div className="note px-2">
                対象期間：{dateFormatter(periodRange.firstDay, 'yyyy/MM/dd')} ～ {dateFormatter(periodRange.lastDay, 'yyyy/MM/dd')}
              </div>
            </Card>
          </Card>
          <Card body className="border-0 mt-4 p-2">
            <div className="fw-bold">報酬取得権利確定課金</div>
            <Card body className="mt-2" bg="light">
              <div className="note mb-2">確定金額</div>
              <h2 className="fw-bold">￥ {numberFormat(earningsData?.rewardConfirmationCharge)}</h2>
              <div className="note">※{dateFormatter(targetDate, 'yyyy年MM月')}の確定課金額</div>
            </Card>
          </Card>
          <Card body className="border-0 mt-4 p-2">
            <div className="fw-bold">月次売上集計</div>
            <div className="note py-2">※{dateFormatter(targetDate, 'yyyy年MM月')}の月次確定売上額</div>
            <hr className="mb-4" />
            {[
              { title: 'バイナリー（左系列）', peoples: earningsData?.binaryLeftPeoples, amount: earningsData?.binaryLeftAmount },
              { title: 'バイナリー（右系列）', peoples: earningsData?.binaryRightPeoples, amount: earningsData?.binaryRightAmount },
              { title: 'パーソナルグループ', peoples: earningsData?.personalGroupPeoples, amount: earningsData?.personalGroupAmount },
            ].map((data, index) => (
              <SalesCard key={index} {...data} />
            ))}
          </Card>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
